import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { commissionSettingsApi } from "./api";
import type { CommissionSettingsForm } from "./types";

export const commissionSettingsKeys = {
  detail: ["commission-settings"] as const,
};

export function useCommissionSettings() {
  return useQuery({
    queryKey: commissionSettingsKeys.detail,
    queryFn: commissionSettingsApi.get,
  });
}

export function useUpdateCommissionSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CommissionSettingsForm) => commissionSettingsApi.update(input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: commissionSettingsKeys.detail }),
  });
}
